export const CUSTOMER_SEGMENT_B2C = 'B2cCustomerSegment';
export const CUSTOMER_SEGMENT_B2B = 'B2bCustomerSegment';

/* eslint-disable import/no-mutable-exports */
let customerSegmentType = () => {};
let CUSTOMER_SEGMENT_TYPE_OPTIONS = [];

export function loadCustomerSegments(locales) {
  customerSegmentType = (type) => {
    if (type === 'B2cCustomerSegment') {
      return locales.customerSegment.defineYourCustomers.tabs
        .businessToCustomer;
    }
    if (type === 'B2bCustomerSegment') {
      return locales.customerSegment.defineYourCustomers.tabs
        .businessToBusiness;
    }
    return type;
  };
  CUSTOMER_SEGMENT_TYPE_OPTIONS = [
    CUSTOMER_SEGMENT_B2C,
    CUSTOMER_SEGMENT_B2B,
  ].map((e) => ({
    label: customerSegmentType(e),
    value: e,
  }));
}

export const customerSegmentAgeRange = ({ min, max }) => `${min}-${max}`;

export { customerSegmentType, CUSTOMER_SEGMENT_TYPE_OPTIONS };
